import { useState } from "react";
import "./recordComplex.css";

import { ReactComponent as NonCompliantIcon } from "../../assets/non-compliant.svg";
import { ReactComponent as CompliantIcon } from "../../assets/compliant.svg";
import { ReactComponent as PartiallyCompliantIcon } from "../../assets/partially-compliant.svg";
import { ReactComponent as PendingAssessmentIcon } from "../../assets/pending-assessment.svg";
import { ReactComponent as NATag } from "../../assets/na-tag.svg";

import DateShow from "../dateShow/DateShow";

import { format, parseISO } from "date-fns";
import ColoredBulletLink from "../shared/ColoredBulletLink";
import { mainCategoryOptions as categories } from "../../data/data";
import { useSelector, useDispatch } from "react-redux";

import { Button, Select as AntSelect } from "antd";
import { Tooltip as AntTooltip } from "antd";

import { assignUser } from "../../store/obligations/actions";
// import { sendEmail } from "../../store/email/actions";
import { renderOptions } from "../../util/basicRenders";
// import { assignToUserMessage } from "../../util/emailTemplates";
import { useNavigate } from "react-router-dom";

const RecordComplex = ({
  type,
  obligation,
  users = [],
  userNameText = "Not Assigned"
}) => {
  const dispatchito = useDispatch();
  const user = useSelector(state => state.user);
  const laws = useSelector(state => state.laws.laws);
  const organization = useSelector(state => state.organizations.organizationId);
  const usersData = useSelector(state => state.organizations.usersData);
  const navigate = useNavigate();

  const loginLink = `http://${process.env.REACT_APP_FILE_HOST}/regcom/login`;

  const [selectedOption, setSelectedOption] = useState(null);
  const [unassigned, setUnassigned] = useState(false);
  const [owner, setOwner] = useState(userNameText);
  const [searchValue, setSearchValue] = useState("");

  //show more functionality
  const [showFullDescription, setShowFullDescription] = useState(false);
  // console.debug(
  //   "INSIDE RecordComplex.jsx - format the date: ",
  //   format(parseISO(obligation?.dueDate), "eeee do MMM, yyyy")
  // );
  //toggle show more handler

  //pop up related
  const [visible, setVisible] = useState(false);

  const handleVisibleChange = visible => {
    setVisible(visible);
  };

  const toggleFullDescription = () => {
    setShowFullDescription(prev => !prev);
    setVisible(prev => !prev); //new line for popup
  };

  const renderDescription = () => {
    return (
      <AntTooltip
        title={obligation?.description}
        arrow={false}
        overlayClassName="description-tooltip"
        mouseEnterDelay={0.5}
        placement="bottomLeft"
      >
        <div className="description-hover">
          <p
            className="description certain-lines"
            style={{ textAlign: "left", paddingRight: "0.75rem" }}
          >
            {/*obligation?.description.length > 225
              ? `${obligation?.description.slice(0, 225)}...`
    : obligation?.description*/}
            {obligation?.description}
          </p>
          {/* {obligation?.description.length > 210 && (
          <div className="description-full">
            <p>{obligation?.description}</p>
          </div>
          )} */}
        </div>
      </AntTooltip>
    );
  };

  const handleInputChange = selectedOption => {
    setSearchValue('');
    setSelectedOption(selectedOption);
  };

  // Filter `option.label` match the user type `input`
  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) ||
    (option?.email ?? "").toLowerCase().includes(input.toLowerCase());

  const unassignUser = () => {
    dispatchito(
      assignUser({
        newItem: { _id: obligation._id, user_id: "0" },
        user,
        organizationId: organization,
        callback: check => {
          setUnassigned(check);
        }
      })
    );
  };

  async function handleClick() {
    dispatchito(
      assignUser({
        newItem: { _id: obligation._id, user_id: selectedOption },
        user,
        organizationId: organization,
        callback: check => {
          setSelectedOption(undefined);
          const userAssigned = usersData?.find(
            item => item._id === selectedOption
          );
          setOwner(`${userAssigned.firstName} ${userAssigned.lastName}`);
          setUnassigned(false);
          // const law = laws?.find(law => law?._id === obligation?.law_id)
          // dispatchito(
          //   sendEmail({
          //     user,
          //     to: [userAssigned.email],
          //     cc: [],
          //     subject: 'Assigned Main Obligation',
          //     message: assignToUserMessage(obligation, user, false, law),
          //     isHtmlMessage: true,
          //     // message: 'HELLO text',
          //     // isHtmlMessage: false,
          //   }));
        }
      })
    );
  }

  const setID = async (value) => {
    dispatchito({
      type: "SET_NAVIGATE_ID",
      payload: { value }
    });
    user.role === "assignedUser"
      ? navigate("/my-tasks")
      : navigate("/my-checklist")
  }

  const hasValue = selectedOption !== null && selectedOption !== undefined;

  return (
    <div className="record-complex-container">
      {/* this has to be changed */}
      <div className="first-column">
        <a
          onClick={()=>setID(obligation._id)}
          // style={{ color: "#725798", textDecoration: "none" }}
          className="record-title"
        >
          <h3 style={{ textAlign: "left" }}>
            {laws?.find(law => law._id === obligation.law_id)?.title}
          </h3>
        </a>
        <h5 style={{ textAlign: "left" }}>
          Article{" "}
          {obligation.article !== "undefined" ? obligation.article : "-"} /
          Paragraph{" "}
          {obligation.paragraph !== "undefined" ? obligation.paragraph : "-"}
        </h5>
        {renderDescription()}
      </div>
      <div className="second-column">
        <span style={{ width: "100%", textAlign: "left" }}>
          {
            categories.find(item => item.value === obligation?.mainCategory)
              ?.label
          }
        </span>
      </div>
      <div className="third-column">
        {obligation?.assessment === "Partially" && <PartiallyCompliantIcon />}
        {obligation?.assessment === "Compliant" && <CompliantIcon />}
        {obligation?.assessment === "Non-Compliant" && <NonCompliantIcon />}
        {obligation?.assessment === "Pending" && <PendingAssessmentIcon />}
        {obligation?.assessment === "na" && <NATag />}
      </div>
      <div className="fourth-column">
        {/* {type === "immediate" && obligation?.assessment !== "Compliant" && (
          <ImmediateActionIcon />
        )}{" "} */}
        {/**if compliant don't show immediate-action icon */}
        {/* {type === "expire" && obligation?.assessment !== "Compliant" && (
          <CloseToExpireIcon />
        )}{" "} */}
        {/**if compliant don't show close-to-expire icon */}
        {type === "default" && null}
        {obligation.dueDate ? (
          <DateShow
            date={format(parseISO(obligation?.dueDate), "d-MMM-yyyy")}
          />
        ) : (
          <div>-</div>
        )}
      </div>
      <div className="fifth-column" style={{ display: "flex", gap: "0.5rem" }}>
        <div
          className={
            user.role === "assignedUser"
              ? "owner-tag-home"
              : "owner-tag-home mt-05"
          }
        >
          <ColoredBulletLink
            text={owner}
            unassign={unassignUser}
            allowClear={user.role !== "assignedUser"}
            cleared={unassigned}
          />
        </div>
        {user.role !== "assignedUser" && (
          <>
            <AntSelect
              className="assign-select"
              dropdownStyle={{maxHeight:"17rem", minWidth: "20rem"}}
              virtual={false}
              placement="bottomRight"
              showSearch
              allowClear
              filterOption={false}
              onSearch={setSearchValue}
              value={users
              ?.filter(b => b._id === selectedOption)
              .map(b => `${b?.firstName} ${b?.lastName}`)}
              onChange={handleInputChange}
              placeholder={
                user.role === "corporateComplianceObserver" ||
                user.role === "groupComplianceObserver"
                  ? ""
                  : "Select"
              }
              disabled={
                user.role === "corporateComplianceObserver" ||
                user.role === "groupComplianceObserver"
              }
              style={{ width: "12.688rem", textAlign: "left" }}
            >
              {renderOptions(searchValue, users)}
            </AntSelect>
            {user.role !== "corporateComplianceObserver" &&
              user.role !== "groupComplianceObserver" && (
                <div id="reassign-button-container">
                  <Button
                    type="text"
                    size="medium"
                    disabled={!hasValue}
                    className="assign-button-rc no-margin"
                    onClick={() => {
                      handleClick();
                    }}
                  >
                    {unassigned ? "Assign" : "Reassign"}
                  </Button>
                </div>
              )}
          </>
        )}
      </div>
    </div>
  );
};

export default RecordComplex;
